import { userStateActionType } from "./action";
import { defaultUserState } from "./state"

const userStateReducer = (state, action) => {
    if (!state) {
        return defaultUserState();
    }

    if (action.type === userStateActionType.setUser) {
        return { ...state, user: action.payload };
    }


    if (action.type === userStateActionType.deleteUser) {
       
        
        return { ...state, user: action.payload };
    }

    return state;
}

export default userStateReducer;
